module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', _vm._b({
    attrs: {
      "clearable": "",
      "placeholder": "Search",
      "prepend-icon": "search"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.stopPropagation();
        _vm.searchString = ""
      }
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }, 'v-text-field', _vm.attrs, false))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-679170f6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/SearchField.vue
// module id = 1665
// module chunks = 3